<template>

    <router-link to="/rewards" class="back-btn text-16 weight-500"> <v-icon
          icon="mdi-arrow-left"
          start
        ></v-icon>Back</router-link>

    <v-divider class="mb-8 mt-3"></v-divider>

    <router-view name="main" class="my-4 my-md-7"></router-view>

</template>



<style scoped lang="scss">
.back-btn {
    display: inline-block;
    color: #fff; // TODO: check this later
}
</style>
